import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';     
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const Login = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
    setLoading(true);
    try {
        const user = await login(values.email, values.password);
        message.success(`Welcome back, ${user.name}!`);

        // DYNAMIC REDIRECT BASED ON ROLE
        switch (user.role) {
            case 'admin':
                navigate('/admin/dashboard');
                break;
            case 'mentor':
                navigate('/mentor/dashboard');
                break;
            case 'mentee':
                navigate('/mentee/dashboard');
                break;
            default:
                navigate('/dashboard');
        }
    } catch (error) {
        message.error('Invalid email or password');
    } finally {
        setLoading(false);
    }
};

const inputStyle = { 
        background: 'transparent', 
        border: '1px solid #444', 
        color: '#fff', 
        height: '45px',
        borderRadius: '8px'
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#0D0D0D' }}>
            <Card style={{ width: 420, background: '#141414', borderRadius: '16px', border: '1px solid #333' }}>
                <div style={{ textAlign: 'center', marginBottom: 30 }}>
                    <img src="/assets/images/logo.png" alt="Logo" style={{ width: 60, marginBottom: 20 }} />
                    <Title level={3} style={{ color: '#fff', margin: 0 }}>Welcome Back</Title>
                    <Text style={{ color: '#888' }}>Login to your Chalom Hights account</Text>
                </div>

                <Form onFinish={onFinish} layout="vertical">
                    <Form.Item name="email" label={<Text style={{color: '#888'}}>Email Address</Text>} rules={[{ required: true }]}>
                        <Input style={inputStyle} placeholder="example@mail.com" />
                    </Form.Item>
                    
                    <Form.Item name="password" label={<Text style={{color: '#888'}}>Password</Text>} rules={[{ required: true }]}>
                        <Input.Password 
                            style={inputStyle} 
                            placeholder="••••••••"
                            // This ensures the eye icon is visible and white/grey
                            iconRender={(visible) => (
                                <span style={{ color: '#888', fontSize: '18px' }}>
                                    {visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                </span>
                            )}
                        />
                    </Form.Item>

                    <Button type="primary" htmlType="submit" block loading={loading} style={{ background: '#fff', color: '#000', height: '45px', fontWeight: 'bold', border: 'none', marginTop: 10 }}>
                        Log in
                    </Button>
                    
                    <div style={{ textAlign: 'center', marginTop: 24, color: '#888' }}>
                        Don't have an account? <a href="/register" style={{ color: '#FE1F08' }}>Register Now</a>
                        <br /><br/>
                        Forgot Password? <a href="/forgot-password" style={{ color: '#FE1F08' }}>Click here</a>
                    </div>
                </Form>
            </Card>
        </div>
    );
};

export default Login;